import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Route guard that restricts access to admin-only pages.
 * Redirects unauthenticated users to /login and non-admin users to /.
 */
export const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const storedUser = localStorage.getItem('user');

  if (!token || !storedUser) {
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(storedUser);
    if (user.user_type !== 'admin') {
      return <Navigate to="/" replace />;
    }
  } catch {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
